// google map as object literal
// from https://stackoverflow.com/a/40642485
// inspired by http://rmurphey.com/blog/2009/10/15/using-objects-to-organize-your-code
map = {
  config: {
    markers: {},
    styles: {
      // poi's
      // https://developers.google.com/maps/documentation/javascript/style-reference
      transit: [
        {
          featureType: "poi.business",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "road.local",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "road",
          elementType: "labels",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "poi",
          elementType: "labels",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "administrative.neighborhood",
          elementType: "labels",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
      ],
      show: [
        // {
        //     featureType: "road.local",
        //     stylers: [{
        //         visibility: "off"
        //     }],
        // },
        // {
        //     featureType: 'transit',
        //     elementType: 'labels.icon',
        //     stylers: [{
        //         visibility: 'off'
        //     }]
        // }
      ],
      default: [
        {
          featureType: "road",
          elementType: "labels",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "poi",
          elementType: "labels",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "road.local",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "transit",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "administrative.neighborhood",
          elementType: "labels",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "administrative.locality",
          elementType: "labels",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "water",
          elementType: "labels",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
      ],
      showroads: [
        {
          featureType: "poi",
          elementType: "labels",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "road.local",
          elementType: "labels", // turn all off, not just labels
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "transit",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "administrative.neighborhood",
          elementType: "labels",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "administrative.locality",
          elementType: "labels",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
      ],
      showroadsnoparks: [
        {
          featureType: "poi.business",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        // {
        //     featureType: "road",
        //     elementType: "labels",
        //     stylers: [{
        //         visibility: "off"
        //     }]
        // },
        {
          featureType: "poi",
          elementType: "labels",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "road.local",
          elementType: "labels", // turn all off, not just labels
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "transit",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "administrative.neighborhood",
          elementType: "labels",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "administrative.locality",
          elementType: "labels",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
      ],
    },
    locations: {
      // original center
      center: {
        lat: 42.378,
        lng: -71.095,
      },
      dblockbuilding: {
        lat: 42.377,
        lng: -71.0945,
      },
      mobileCenter: {
        // lat: 42.37,
        lat: 42.37786, // center mobile
        // lng: -71.08,
        lng: -71.09491, // center mobile
      },
      unionSquare: {
        lat: 42.37966,
        lng: -71.09625,
      },
      initialUnionSquareLogo: {
        // new center - phase II
        lat: 42.37789,
        lng: -71.0949,
      },
      realUnionSquareLogo: {
        // real location
        // lat: 42.3777,
        // lng: -71.09430
        // new with building labels
        lat: 42.3779,
        lng: -71.0957,
      },
      unionSquareZoomCenter: {
        lat: 42.378,
        lng: -71.095,
      },
      mobileUnionSquareZoomCenter: {
        // lat: 42.3755,
        lat: 42.378,
        // lng: -71.09625,
        lng: -71.0947,
      },
      massiveUnionSquareZoomCenter: {
        lat: 42.379,
        lng: -71.09625,
      },
      newTStop: {
        lat: 42.37736,
        lng: -71.0951,
      },
    },
    labels: {
      "1 mile": {
        lat: 42.378,
        // lng: -71.0788
        lng: -71.0761,
      },
      "2 miles": {
        lat: 42.378,
        // lng: -71.05895
        lng: -71.05595,
      },
      "3 miles": {
        lat: 42.378,
        // lng: -71.0393
        lng: -71.0363,
      },
      "Logan Airport": {
        lat: 42.3656,
        // lng: -71.038
        // lng: -71.034
        lng: -71.03,
      },
      Allston: {
        lat: 42.3539,
        lng: -71.1337,
      },
      "Back Bay": {
        lat: 42.35,
        lng: -71.08179305,
      },
      "Downtown Boston": {
        lat: 42.3601,
        lng: -71.0589,
      },
      "Davis Square": {
        lat: 42.3967,
        lng: -71.1223,
      },
      Cambridge: {
        // lat: 42.372,
        // lng: -71.099
        lat: 42.369,
        lng: -71.09999,
      },
      Charlestown: {
        // lat: 42.3782,
        lat: 42.3765,
        lng: -71.061,
      },
      "Harvard Square": {
        lat: 42.377,
        lng: -71.1167,
      },
      "Kendall Square": {
        lat: 42.3629,
        lng: -71.089,
      },
      "Longwood Medical Center": {
        // lat: 42.345,
        lat: 42.341,
        lng: -71.104149,
      },
      MIT: {
        lat: 42.359,
        lng: -71.095,
      },
      "Porter Square": {
        lat: 42.3889,
        lng: -71.1194,
      },
      Seaport: {
        lat: 42.346,
        lng: -71.0389,
      },
      Somerville: {
        lat: 42.3876,
        lng: -71.0995,
      },
    },
    routes: {
      bus: {
        linedata: {
          85: "}{paGr}zpLEt@MzDOvEo@Cc@CUGWM{@o@????qA}@QKmB`Gk@`CA\\M`@{@vCcCdDoA~A??IJ_BtBm@r@????cBzBw@dAa@f@aBtBs@|@??KPwBlCcBzB??MNeHkDq@Yu@]qAo@o@[o@[??SI_AMoATeCj@qCl@??ODuCl@kE~@??QDmCj@e@JMBuCj@{Dv@Eo@]\\SLKFSPUTKHA@??ONqAr@w@^y@l@a@TW^MREHo@v@GF??q@h@{@|@}ArAo@l@_B|AoBlB??OLmCjKc@bB??EVo@dCm@`CMb@??i@vBmBkAJc@",
          86: "iqkaGxjgqL?@?bA]x@EJSb@Yb@OPg@n@e@Ta@Ve@l@qAfB_AlA??Y\\sBdCm@n@a@ZUX??Y\\gG~Ge@b@KFMBO@Q?IA??GA[MeCwA??MIeAi@y@e@wCeBaAk@a@Q??UMQGa@C_@?c@Dk@FY?a@Ga@M[M??A?yAm@i@UQEOC_@?i@Ba@HUF??G@g@\\u@b@[P}AbAy@^SFK???O@]A_@Ee@Uc@Wa@W[QQGs@E_@A??a@CYQ}@s@[Ui@[cCwAuAw@}@c@YQ??a@UwBeAeAm@{As@q@a@w@c@}@a@MI??eAk@e@Wk@_@uAu@_@S??kBgAgDeBgAi@??OI{EeC_Ae@{A{@??ICmE_CUM??kAo@yBoA?]Ec@M{@W}BCQ??c@}DWyBg@uE??i@iFUsBGq@??C]_@kES_EG{@U_EY}D??CYUyCGu@K_BAk@@cBHwAPwAFe@??Fm@Lu@@}AGiBGcBEs@[]_@m@[g@??iDeFmAmB{BiDYc@Y[CGu@_AgAkAkAgAk@m@WU??w@w@iD}Cg@c@q@i@m@g@}@u@qB_BaCmBoAcAUQ}AgAg@f@ML??m@j@e@ZMDQBGl@g@fB_AtCU[kAo@ZmAV_ASWQ[Os@C}@Es@@q@Ck@G{@G}@I}@Ie@Qa@a@c@g@Sk@OA???]Gk@Ck@A[?]BU?sAHg@DWDODKJMPM\\KNLRDF`Bm@t@[bAULUDOBUAOEQOQ}@Oe@YUUMWKYEa@Ac@BMv@sGFs@B_@HcBFeB@aBoAG{AOg@I??QEMy@QwAa@kCI{@CO??]sCi@uDk@uE??CWMaAi@cEM}@UiBc@}C??CWm@gFw@oE??EU_@qBa@kCO{@IaAS{B??CWEq@?[?o@@c@FeA??BWBk@D{@A]Ae@IsAEo@MaCAY??A]GwAQmDEo@Ak@?e@BSJi@b@uAPm@??p@_Ci@Wa@YOUAa@?k@HaADqBAe@??AYGgAQiAu@{C@gC???SA_@EUEUISQUQCKAIBa@RORcAl@e@H??KB{A^eAh@u@n@s@]_@O??ICMESIc@Uy@a@dAgAp@s@rBiBhBaBbBcBVMY{Ac@yC??CSK_AGm@UoCKmAKgB??Eg@S{CYgCMuAMwAEe@??KoAAMMwAKuCKuAAOE[??OiAUoA{@iDSy@i@sBWiAu@wCGUY^KIKCeA@Q?_@@SBOFOLMRMTGRAT@PDPN\\PVRF",
          87: "k`{aGlpgqLK`@CXBPBLLXNUdByBbAiAKYwAgBdB}Fx@kC~@uCx@qCNc@??f@eBx@gClA_E??HS`A_DrA}DNa@??t@oB`AiC`AiCN_@??h@uA^cAFQzA}DNa@??Rk@f@oAr@kBPg@??\\_Ab@iAp@iBNa@??`@iAVy@Z_AfAqCTm@b@J`@CZYPo@AMOO??AASKOI^cA\\aAf@iATo@v@kAT[??BEdA{ArAqBt@kA??LQVa@`@eAp@gBJ]??Rk@|@c@TMfAa@??NIbCw@nCcA@AXS??`BgApByAxBaB??NMXUdBqAdAu@p@k@h@a@pCyB??^Y|@i@x@_@^U^SpB}@h@_@??lAw@^S~@e@vAq@XO??jBaA|@k@HIvAoAzAuAh@e@DE??LMb@i@RWhAyAfAgAz@_A`BaB????^Wp@w@ZYh@e@jAkAz@u@x@o@??VUhDuC|DgDXU??^[d@DVLVo@v@iBv@iBRi@Pe@??Rg@Vy@`@cBTcAh@_EFk@Lu@??PoARaBL{@l@iE??DUVmBf@qDLaAViBRmA??@Ar@}Ch@kCd@mB??FUR_AZsAn@uCZwARcAHW??FUZeAh@wBv@gCLa@z@sCTu@DK@???FMFIHGt@WEo@Ak@?e@BSJi@b@uAPm@??p@_Cf@qB`@}AZqA??DQr@wCx@}CZqAVgA??DKBIxAcE`@wAZy@??@Cx@}Bp@eBf@kAj@w@^c@Vg@ZcAzAqDz@{Bf@uAvByF??@At@{BDKh@sAx@qBdBiE??Rk@\\u@v@kBd@iA`@oAVy@ZiA^SJENYZy@",
          88: "alyaGt~cqLAASKOI^cA\\aAf@iATo@v@kAT[??BEdA{ArAqBt@kA??LQVa@`@eAp@gBJ]??Rk@|@c@TMfAa@??NIbCw@nCcA@AXS??`BgApByAxBaB??NMXUdBqAdAu@p@k@h@a@pCyB??^Y|@i@x@_@^U^SpB}@h@_@??lAw@^Sr@eAn@gAm@k@WY{@}@eBiBHY??x@iCfAiDZ}@x@_CLc@??`@sAx@_Cv@eCbAwC??FUjAmD|@yCNa@??v@sB`AwCNa@??l@cBfA_Dv@uB??FUbAyCNa@??l@cBj@}Ar@oBb@{A`@yA??FS|@uDr@{C??FUn@qCt@_Dl@eC??DQz@oDTcAfAwE??FUz@sD~@}Dv@oC??HU|@}CjAcE??HSt@kCh@oBVs@b@gARSTUZI????JK^YNWFQHEHEL?TANOnAs@p@g@??NKhAi@l@_@l@_@`@Q`@OdAUv@KFMJOJIPENCLCB???F?LAHBDFBLPCd@KlASbAOtFw@vAUp@W`@wAZy@??@Cx@}Bp@eBf@kAj@w@^c@Vg@ZcAzAqDz@{Bf@uAvByF??@At@{BDKh@sAx@qBdBiE??Rk@\\u@v@kBd@iA`@oAVy@ZiA^SJENYZy@",
          91: "mbuaGbcypLx@ELGPO@MAUGg@c@yAGMKIKCeA@g@_@CSE_@d@q@Te@N[DSJJJPHVV|@\\rAFTt@vCVhAh@rBRx@z@hDDT??Nx@TdB@NJtABt@??F~ALvA@LPtBLvALtAXfCRzCDd@??JhBJlATnCBR??BXJ~@f@lDRfA??DRWLcBbBiB`BsBhBq@r@eAfAiAm@YQ??WS}@y@IG??kB}AuAoA_@Uu@g@Kd@??w@tDg@zBWjAa@jBG^jA^zBl@fATbC`@dBXx@NPBT?TAVGnAs@p@g@??NKhAi@l@_@l@_@`@Q`@OdAUv@Kb@GjAQ`@dA`@`AH\\??j@|BPhAFfA@T??@h@EpBI`A?j@@`@NT`@Xh@VcAlDQh@??Qj@Kh@CR?d@@j@Dn@zDw@pCi@??BALClDu@`]bTxAbAdBfAfAp@f@ZZP??`F~C??PHxDfC??NJ`BdAtA~@~DdC??NJZ^pA`Bb@p@`@f@NXDRFd@F`ABn@??DpAHdBp@uAlAwBcBkBa@e@",
          CT2: "mykaGpq{pLbAnAZ\\fA~AZd@YRMPQVENQ\\Sn@Od@}@|Cg@`Bc@|AELk@xBo@tBu@tCET??GVQp@Mb@ENzAnF~AlFrA|ET~@r@|B??JXk@pBENo@`C]nAqAtEYz@g@dBm@|B@@m@tBSp@Qf@e@bA??O\\iCnFmCwCwB}B[_@YY??iBoB_B_BmBqBmBuBW[u@w@OOo@q@aBxBq@h@y@x@s@j@SLOFc@T_@POH??[LQHs@`@kDvAYLoAb@??KDmAb@iAf@iAd@GB??QJc@`DCLi@tI???@I`@MZGLGH]XQDc@JeBJ[BODQDq@v@En@WBOJ????I^If@KZGXITMVsAMsDUq@GqAKw@Ia@GUOGGMc@NqAPgBDa@?IDm@?e@A{ADiC?_ABkACyAK}EIwBa@Fa@Dg@D_@LcA^YPMJQT??STWw@_AyBiB_FgCeGmCiHaBsEq@aByAoDiAoCWo@kCsGuAmDyAkD??Ui@wCuHkA_DuBoFGSQYIGQENkEJwCo@Cc@CUGWM{@o@????qA}@QKmB`Gk@`CA\\M`@{@vCcCdDoA~A??IJ_BtBm@r@cBzBw@dAa@f@aBtB_AnAwBlCqBjCeHkDq@Yu@]qAo@o@[o@[??SI_AMoATeCj@aDr@uCl@}EdA_Ak@YSQKSMsA}@YO??_BcA]Sw@c@i@Wa@YOUAa@?k@HaADqBC_AGgAQiAu@{C@gC???SA_@EUEUISQUQCKAIBa@RORcAl@q@L{A^eAh@u@n@s@]i@SMESIc@Uy@a@dAgAp@s@rBiBhBaBbBcBVMY{Ag@mDK_AGm@UoCKmAKgB??Eg@S{CYgCMuAMwAEe@??KoAAMMwAKuCKuAAOUeBUoA{@iDSy@i@sBWiAu@wCGUY^KIKCeA@Q?_@@SBOFOLMRMTGRAT@PDPN\\PVRF",
        },
        polylines: {},
        labels: {
          // close in
          // '85, CT2': {
          //     lat: 42.3754,
          //     lng: -71.09512
          // },
          // '86': {
          //     lat: 42.37978,
          //     lng: -71.0905
          // },
          // '87': {
          //     lat: 42.3807,
          //     lng: -71.0985
          // },
          // '88': {
          //     lat: 42.3772,
          //     lng: -71.0893
          // },
          // '91': {
          //     lat: 42.3749,
          //     lng: -71.097
          // },

          // further out when zoomed out
          "85, CT2": {
            lat: 42.369,
            lng: -71.095,
          },
          86: {
            lat: 42.3815,
            lng: -71.0831,
          },
          87: {
            lat: 42.3819,
            lng: -71.1025,
          },
          88: {
            lat: 42.3731,
            lng: -71.0815,
          },
          91: {
            lat: 42.37,
            lng: -71.1005,
          },
        },
        labelMarkers: {},
      },
      subway: {
        linedata: {
          orange: "an_bG|_xpLpBPrCZXBTBP@P@~Dd@dANlATjBd@tDhALDNDhA\\pIbClGjBz@ZhA\\xA`@XJpBl@??ZHpBn@HBfHvBfF~AhDbApA\\bAVND`Er@nALvCVfBLfFDb@?dBAjCEfB?pFDrHF~HFfB?vAC~FFpQJpB?|C@P?`B?V?X?h@B??l@DfEFL@f@BpCDxDFfABfA?lCBdB@fABnC@|C@tO@`ECfCI??|@ElESdCGdCAzA@pEEdBCnBItAAdBA^AT@nAAd@@`A?VAbC?fABzAD??nBDR?Z@v@@`DKtFCn@AZC`@Gr@Q\\MHEb@MzA{@zJeIlBaBhBoBzA}BlAoBrB_EVw@r@oBvAiE??DId@cBxCkGpGmK@Cda@o_@PO??tHkGbCuCh@e@b@Y????`@Sr@IlMg@zGB??T?vC?N@VN`ElDvAvBbBrBtA~A????v@t@hAtAhDbDb@f@t@p@VJj@Nh@@n@Bz@F??RBdD`@|B^XJRLz@`AxBvB|@N??xATNP`HrRJd@BZAf@OzCCbAApFCvG@hC?~F@t@@bB@jAFlAJ~AJf@???@Jb@DLRb@T^v@dA|AxBbB~BnHlJ^f@xAlBJHn@x@rBbClDnEt@fA??Zd@b@n@b@l@nDxEjN`RfAtApCrDb@h@RV??tCxDRTjLzNNRfEnFNN~AhBn@n@NJ`@\\????|@t@dE~CnA|@bAn@n@X`@Vd@R|@^\\Rf@Tp@Xn@R|@T~@ZpA`@l@NZHtEpAHBf@LbHrCvAr@??LFRLf@\\PJvA|@lA~@|AhAvCbCfDpCnA|@hCbBv@b@vAt@lAj@VL??JDd@TtBz@hA^RFvD`AdAZhBl@pA\\??~CfAzAh@vDfBxC`BXNb@T??NJdAj@~CdB|@h@h@Zv@h@fDhBHDnFvCdAn@vC`B~BrAvA~@|CjBrA~@hBhALJl@d@NHNJnDvBhAr@",
          blue: "g|zaGbphpLzD~AdBh@bBb@j@HtC\\bAFbADjA?|@?z@C`BIZCD???tAGXATCrAS^GxIs@hBMjHm@lHm@jFc@rAEb@?P@\\@L?fAJ|@NbAR`A\\nAf@nAr@TLLH??vCbBxCfBrC~A`FxClAp@|A|@lFzCnBhA~AhAhAx@TTh@f@^`@??PPb@l@nAfBb@v@x@tAlAjCRj@Z|@FNNZVdAfAdFDPLp@v@dDHZH^R`AFTNn@v@dD??d@pBNp@HZPx@`@lBpBlIvB`J??DNd@rALVPVbD~EnLdQJNFH|A~BZ^R`@P`@Rd@\\hANl@Lx@VpBFx@@fAC|J@vAFv@Hv@Lt@Jd@Pj@VbA??ZlAn@|BbAvDRh@Rd@T`@V`@DFTXt@~@vBnCbArAd@x@`@z@|@fBl@~@b@f@f@d@`@b@j@\\tAbA`@\\n@p@x@`A??l@t@JLHH|@fABDFHrDnE`@j@DHBDFLXp@Jb@Jd@Dt@B|N@VDVDPPV~AlB`B~Br@bAdApAvBpChDnCz@t@??tNbMre@jc@n@~NNdA^rAJx@Fd@?F??PlBbB~VLnC?zA??AhA?FKbBOpBG^Ij@I\\O^EF??MLQNSHYNgAjASNYL_@JE@KJONKTKV_A~CIp@Kr@CNCn@",
          red: "}nwaG~|eqLGyNIqAAc@S_CAEWu@g@}@u@k@u@Wu@OMGIMISQkAOcAGw@SoDFkCf@sUXcJJuERwHPkENqCJmB^mDn@}D??D[TeANy@\\iAt@qB`AwBl@cAl@m@b@Yn@QrBEtCKxQ_ApMT??R?`m@hD`Np@jAF|@C`B_@hBi@n@s@d@gA`@}@Z_@RMZIl@@fBFlB\\tAP??~@L^?HCLKJWJ_@vC{NDGLQvG}HdCiD`@e@Xc@b@oAjEcPrBeGfAsCvMqVl@sA??jByD`DoGd@cAj@cBJkAHqBNiGXeHVmJr@kR~@q^HsB@U??NgDr@gJTcH`@aMFyCF}AL}DN}GL}CXkILaD@QFmA@[??DaAFiBDu@BkA@UB]Fc@Jo@BGJ_@Lc@\\}@vJ_OrCyDj@iAb@_AvBuF`@gA`@aAv@qBVo@Xu@??bDgI??Tm@~IsQj@cAr@wBp@kBj@kB??HWtDcN`@g@POl@UhASh@Eb@?t@FXHl@Px@b@he@h[pCC??bnAm@h@T??xF|BpBp@^PLBXAz@Yl@]l@e@|B}CT[p@iA|A}BZi@jBeDnAiBz@iAf@k@l@g@dAs@fAe@|@WpCe@l@GTCRE\\G??~@O`@ELA|AGf@A\\CjCGrEKz@AdEAxHY|BD~@JjB^fF~AdDbA|InCxCv@zD|@rWfEXDpB`@tANvAHx@AjBIx@M~@S~@a@fAi@HEnA{@fA{@|HuI|DwEbDqDpLkNhCyClEiFhLaN`@c@f@o@RURUbDsDbAiA`AgAv@_AHKHI~E}FdBoBfAgAfD{DxDoE~DcF|BkClAwALODEJOJK|@gATWvAoA`Au@fAs@hAk@n@QpAa@vDeAhA[x@Yh@Wv@a@b@YfAaAjCgCz@aAtByBz@{@??|FaGtCaDbL{LhI{IzHgJdAuAjC{CVYvAwA??JIl@a@NMNM\\[|AuArF_GlPyQrD_ErAwAd@e@nE{ErDuD\\a@nE_FZYPSRUvL{Mv@}@Z[JILKv@m@z@i@fCkAlBmAl@[t@[??h@WxBeAp@]dAi@p@YXIPEXKDALENEbAQl@Gz@ChADtAL~ARnCZbGx@xB`@TDL@PBzAVjIvA^FVDVB|@NjHlAlPnCnCd@vBXhBNv@JtAPL@|BXrAN??`@FRBj@Bp@FbADz@?dAIp@I|@Mx@Q`AWhAYlBs@pDaBzAs@nBgAZQJGJGhAs@RKVMNKTMf@YdHcEzBmApAw@`GmDLI@AHGlEwClAi@hA_@v@Up@ObB]z@Kr@Ir@EZCpA?dCRf@DpAHvANrE`@bDTr@DfMdA`CJvBRn@DnCLnBPfAFV@",
          "green-b": "avoaGtivpLT\\z@dAZ^^b@VZh@b@n@\\\\BXNp@TfBv@RH`@PPFNPh@R`@T\\LB@??tAZHJDJBLB^Y`LJbBRbCd@bDvArI??F^bJng@??Lr@^`CXbBzIfg@F`@@N?Rc@`JCl@Ez@??Cl@?jAPtRAPCPGVM^IN{AjBu@`AGPALAR?nC?D???BLpFDpGA`BWhFWxEKrBEj@??IjASfDU~Da@`H??G~@o@pKM~B??QtCk@tI]tFIfA?DE`@Gv@AZCV]xFMjCGt@??u@|L????ShD]lFK~BAT??AXIlAUpDa@jG???JYzEi@rI?X@NHPX`@??NVf@n@p@jAXh@d@~@b@dATn@Nl@Jd@PrADp@@d@?fAAj@MxBGxA?l@@h@Df@Fb@Nj@r@jB??DJ|@dC^~@r@pBbAhCtAzD^`A@@??\\`ANl@Fj@Fh@@f@?^A`@Eb@Kn@On@y@fD????e@~BI`@C\\A\\?f@Dv@Hh@Jb@Td@PXHFTJVJ??x@Vf@LhCTb@Hp@RxAj@~Az@ZTPHl@ZtCdBz@l@tAx@D@??dAn@v@h@n@f@\\\\\\`@^d@t@nAVj@Zx@\\dAR~@Ln@Hl@Dp@??BZDh@D|A?|@ChBAj@BbBF~@Fn@P|@ZrA`@jAj@nABD??|@xAv@fAZ^`@^b@^b@Vn@^b@Rf@Tf@RXPl@f@DDLPRX????B@JVDRBTM`BEXMj@Mf@o@jBeArCe@jAa@lAWv@[vAYvA??EVSjAKv@WbCKzAInAE`BAdEK|K@pD@xAFlBJlBA|@AVC^??",
          "green-c": 'kpqaGv_vpLlIkHxAcBLQh@c@LIZQ??NGREZC`@I`GSf@AT@TNtE|Dp@n@PPRN??XVZTdElCt@p@tB~Bn@t@`@b@VPTXp@z@??T\\z@dAZ^^b@VZh@b@n@\\\\BXNp@TfBv@RH`@PPFNPh@R`@T\\LB@??tAZHJDJBLB^Y`LJbBRbCd@bDvArI??F^bJng@??Lr@^`CXbBzIfg@F`@@N?Rc@`JCl@Ez@??Cl@?jAPtRAPCPGVM^IN{AjBu@`AGPALAR?nC?D???BP|B?DBjBBtA@hEBN??@RfFzZjFpXr@bE\\`BNp@DP??Pl@Jb@z@rELx@TxAXtA~@dF??@JTlAf@nC`@vB~@jFDR??Nx@n@tDr@lDN`ATlA??RpAbB`Jb@vBRhAZnBDd@@XFd@??BTDTR~@bAhGf@bEJv@f@~CX~A??Jf@BN`@fBHXJVH\\^lANh@d@rBThAPhAPbA??Hj@RfBL~AHdBDv@??Bn@@h@@zA?nDA~B@x@D`AJdBFh@DXJl@FR??DNTt@DLHd@TtAfAlHh@hD??F`@AQ\\dCf@fDj@xDVxB??Jx@D`@PtAb@pD^vCRhBJv@L`AFZ??z@dHf@jDDXPbA^tC"',
          "green-d":
            "{hpaGdxupLXVZTdElCt@p@tB~Bn@t@`@b@VPTXp@z@??T\\z@dAZ^^b@VZh@b@n@\\\\BXNp@TfBv@RH`@PPFNPh@R`@T\\LB@??tAZHJDJBLB^Y`LJbBRbCd@bDvArI??F^bJng@??Lr@^`CXbBzIfg@F`@@N?Rc@`JCl@Ez@??Cl@?jAPtRAPCPGVM^IN{AjBu@`AGPALAR?nC?D???BP|B?DBjBBtA@hEBN??@RfFzZLLHHPFx@Hl@LTFRJNT~AlD|@pBvAbD??DJNXDLNV\\v@^t@fCvEfApBtBxDvCpFb@t@`@l@f@p@r@x@l@l@l@h@LF??l@b@n@Z`@NLDRHv@Td@NhAZlBZfATlA^lCbA\\N~@f@jBv@lB`AhAh@JFLHl@ZTNf@`@l@f@lAjAhApAb@p@d@x@^t@f@~@b@`AVn@??\\|@Vt@t@~Bj@bBHTDNJTX`AJh@P`AN`AFl@Bb@@v@F`F?PHtEBnB@z@DdAJbBJz@HhADtA?n@?j@AXATMtBC\\Ez@??WxFQxEU`EOtDALCVS`DIdA[nBMp@Op@]jAg@rAcBpD_AnBg@hAuAhCcErIgAfC]dAg@tBEPW|AA@??Iz@ElA?RAVCjA?lB@tABbAFr@Hp@Lr@J\\F^NrAHv@n@~GF~@F~@?n@Dz@Dt@Ft@LdANdA??Lr@FZJf@^lAh@pA`@~@f@dAh@`AvAjCfF`Kt@|ApClFv@`BFJHRp@jAnHpNdC~E`B|C^v@~@xBZ~@^vAXjATnAN|@TdC@FJdC??@V?J?NA~BClAI`BSpBg@fE}@dIa@fD]`Du@jGm@lFWzBiBfPE`@Gf@WdCc@hDYtCc@jDe@bEQtAeAxI_@lDMfCGzCAnA?dABbBLxCV|CZfCXpBDPHZPx@n@dCTv@BH??X|@l@fBJXHTj@vAx@hBHPDLvCtHZr@Zr@|@xBPh@Vp@`@dAn@|Ap@`Bx@nBlCrGfBfEDHDHnBdFz@zBd@z@DFBD`@p@r@~@z@dA`A`AbAbAn@p@FD??HHVRhEpEvBvBzAxANPBBPRLP`AdA`@h@d@n@\\p@Xn@Tl@Xz@XrARlAHp@Fz@DzA?n@EvBCj@KdAQhAUfASx@_@hAWp@M\\iApCk@~A??IRiCbHuBtFaApCgDbJy@vBwB`GqAfDkCjHk@xAq@jBYt@_AhC{@vB[~@a@`Ac@~@s@rAsAtB??A@s@hAIJINgBrCiBpCkAjB_AbBs@tA{EpLcAlC_D~He@dAaAhC_AzBmCzGUn@Uj@c@dAmAzCi@pAu@jB??q@bBGVKXKTw@jBs@hB_CbGwBpFyArD{@zBQd@i@jAmAtCMZe@xAK`@",
          "green-e": "mqraGrfypLFOLWJ]Dc@L{A@EDm@DSF]TcAPu@Xu@rBgFv@kBpA_DjBoEdBmEn@{A@C??z@iCvAgDDMd@kAPe@Ti@To@Rq@Ru@TuAJcAJs@^aC\\_ABO@OCc@Ea@Mm@g@}AcB_FK[CWCi@?SBOFQtCsCNO??lIkHxAcBLQh@c@LIZQ??NGREZC`@I`GSf@AT@TNtE|Dp@n@PPRN??XVZTdElCt@p@tB~Bn@t@`@b@VPTXp@z@??T\\z@dAZ^^b@VZh@b@n@\\\\BXNp@TfBv@RH`@PPFNPh@R`@T\\LB@??tAZHJDJBLB^Y`LJbBRbCd@bDvArI??F^bJng@??Lr@^`CXbBX`AHRPFlBg@NBhHhAv@Z^XV\\xEzG^h@??RXxMfQ??l@v@`@f@~C|DfAzAVd@d@`ANd@Pl@\\jAXbAr@xB??Ph@f@~AzAbFHVp@bCp@|B^nAT`AfAxDX`A~A`FXhA??d@dBbB~F|B|Hl@|Bj@dB??JZNh@\\dAj@lBLj@l@lCRv@|AtFDNj@nBPh@DL??Rr@Nh@`@dAZr@??HPNX\\|@Nh@Lp@Dd@?Z?pA@tCB~@?v@@v@?v@@l@D^??@L@FFXH`@Xt@N^L\\n@nAZh@T`@P\\PZPXDDD@ZGTI??tDcA~Bq@??VG`Bo@fAa@d@U^e@PYVa@HKJMFENCB@BB",
        },
        polylines: {},
        labels: {
          93: {
            lat: 42.3762,
            lng: -71.0749,
            icon: "i-93a",
            hideText: true,
          },
          Airport: {
            lat: 42.374262,
            lng: -71.030395,
            icon: "blue-t",
          },
          Alewife: {
            lat: 42.3964,
            lng: -71.142,
            icon: "red-t",
          },
          Arlington: {
            lat: 42.351902,
            lng: -71.070893,
            icon: "green-t",
          },
          Aquarium: {
            lat: 42.359784,
            lng: -71.051652,
            icon: "blue-t",
          },
          Assembly: {
            lat: 42.392811,
            lng: -71.077257,
            icon: "orange-t",
          },
          "Ball Square": {
            lat: 42.399983,
            lng: -71.111103,
            icon: "green-t",
          },
          Boylston: {
            lat: 42.35302,
            lng: -71.06459,
            icon: "green-t",
          },
          Bowdoin: {
            lat: 42.361365,
            lng: -71.062037,
            icon: "blue-t",
          },
          Broadway: {
            lat: 42.3429,
            lng: -71.0572,
            icon: "red-t",
          },
          Chinatown: {
            lat: 42.3522,
            lng: -71.0627,
            icon: "orange-t",
          },
          "College Avenue": {
            lat: 42.408153,
            lng: -71.117325,
            icon: "green-t",
          },
          "Community College": {
            lat: 42.373622,
            lng: -71.069533,
            icon: "orange-t",
            showInitial: true,
          },
          Central: {
            lat: 42.365486,
            lng: -71.103802,
            icon: "red-t",
          },
          "Charles/MGH": {
            lat: 42.361166,
            lng: -71.070628,
            icon: "red-t",
          },
          Copley: {
            lat: 42.349974,
            lng: -71.077447,
            icon: "green-t",
          },
          Davis: {
            lat: 42.397,
            lng: -71.123,
            icon: "red-t",
          },
          "Downtown Crossing": {
            lat: 42.355518000000004,
            lng: -71.060225,
            icon: "orange-red-t",
          },
          // 'East Somerville': {
          //     lat: 42.38072,
          //     lng: -71.0875,
          //     icon: 'green-t'
          // },
          "Gilman Square": {
            // lat: 42.3881242,
            // lng: -71.0959518,
            lat: 42.387778,
            lng: -71.096447,
            icon: "green-t",
          },
          Harvard: {
            lat: 42.373362,
            lng: -71.118956,
            icon: "red-t",
          },
          Haymarket: {
            lat: 42.363021,
            lng: -71.05829,
            icon: "green-orange-t",
          },
          "Hynes Conventian Center": {
            lat: 42.347888,
            lng: -71.087903,
            icon: "green-t",
          },
          "Kendall/MIT": {
            lat: 42.36249079,
            lng: -71.08617653,
            icon: "red-t",
          },
          // 'Lechmere': {
          //     lat: 42.370772,
          //     lng: -71.076536,
          //     icon: 'green-t'
          // },
          "Magoun Square": {
            lat: 42.393722,
            lng: -71.106592,
            icon: "green-t",
          },
          "Malden Center": {
            lat: 42.426632,
            lng: -71.07411,
            icon: "orange-t",
          },
          Maverick: {
            lat: 42.36911856,
            lng: -71.03952958,
            icon: "blue-t",
          },
          // 'North Station (9 min)': {
          // 'North Station': {
          //     lat: 42.3666,
          //     lng: -71.06211,
          //     icon: 'green-orange-t',
          //     showInitial: true
          // },
          "Oak Grove": {
            lat: 42.43668,
            lng: -71.071097,
            icon: "orange-t",
          },
          Porter: {
            lat: 42.388333,
            lng: -71.119028,
            icon: "red-t",
          },
          "Park Street": {
            lat: 42.35639457,
            lng: -71.0624242,
            icon: "green-red-t",
          },
          Prudential: {
            lat: 42.34557,
            lng: -71.081696,
            icon: "green-t",
          },
          "Science Park": {
            lat: 42.366664,
            lng: -71.067666,
            icon: "green-t",
          },
          "South Station": {
            lat: 42.352271,
            lng: -71.055242,
            icon: "red-t",
          },
          "State Street": {
            lat: 42.358978,
            lng: -71.057598,
            icon: "blue-orange-t",
          },
          "Sullivan Square": {
            lat: 42.383975,
            lng: -71.076994,
            icon: "orange-t",
            showInitial: true,
          },
          Symphony: {
            lat: 42.342687,
            lng: -71.085056,
            icon: "green-t",
          },

          // unionSquare: {
          //     lat: 42.379660,
          //     lng: -71.096250
          // },
          // 'Union Square': {
          //     lat: 42.37735,
          //     lng: -71.0951,
          //     icon: 'green-t'
          // },
          Wellington: {
            lat: 42.40237,
            lng: -71.077082,
            icon: "orange-t",
          },
        },
        labelMarkers: {},
      },
    },
    tstations: {
      "Lechmere Station (5 min)": {
        lat: 42.37145,
        lng: -71.0765,
      },
      "North Station (8 min)": {
        lat: 42.3666,
        lng: -71.06211,
      },
      "Union Square Station": {
        // lat: 42.37735,
        // lng: -71.0951
        lat: 42.37735,
        lng: -71.0946,
      },
      "Washington St. Station": {
        lat: 42.38072,
        lng: -71.0875,
      },
    },
    circles: {
      one: {
        radius: 1609.34, // 1 mile
      },
      two: {
        radius: 3218.68, // 2 miles
      },
      three: {
        radius: 4828.02, // 3 miles
      },
    },
    buildingLabels: {
      10: {
        lat: 42.37858,
        lng: -71.094,
      },
      50: {
        lat: 42.37775,
        lng: -71.09442,
      },
      60: {
        lat: 42.37675,
        lng: -71.095,
      },
    },
    buildingLabelMarkers: {},
    labelMarkers: {},
    tstationMarkers: {},
    concentricCircles: {},
    iconPath: "/assets/svg/icons/",
    nearbyType: null,
    nearbyRadius: 200, // 1/8 miles in meters, we don't want to see all the outside stuff around USQ
    // init here for scope reasons, https://stackoverflow.com/q/16912892/4504073
    labelOrigin: null,
    infoWindow: null,
    service: null,
    // transit layer, from https://developers.google.com/maps/documentation/javascript/examples/layer-transit
    transitLayer: null,

    // mobile
    mobileZoomLevel: 12, // closer on 2018.05.25 so more like bostondesignmarkt.com
    mobileSecondaryZoomLevel: 15, //

    // desktop
    desktopZoomLevel: 14,
    // desktopZoomLevel: 18, // icon testing
    secondaryZoomLevel: 17, // one further away on 2018.04.10 in order to show green line station

    // extra large display
    massiveZoomLevel: 14,
    massiveSecondaryZoomLevel: 17,

    // work page zoom level
    workZoomLevel: 17,
    // workZoomLevel: 18, // testing

    restaurants: null, // init global so when call results from google cache file, can send to another function
    tMarker: null,
    dBlocks: {},
    dBlocksAreSet: false,
    dBuildingsAreSet: false,
    buildingsAreVisible: false,
    dBuildingLabelsAreSet: false,

    subwaysInitialized: false,
    bussesInitialized: false,

    greenLinePath: {},
    mileMarkerLine: {},
    // currentPhasePath: []
  },

  /**
   * run these on initial map startup
   **/
  // init: function(page = 'home') { // broke IE11
  init: function () {
    definePopupClass();

    // check for mobile on init
    var initialMapCenter;
    if (document.body.id == "work-page") {
      initialMapCenter = map.config.locations.unionSquareZoomCenter;
    } else if (site.isMobile) {
      initialMapCenter = map.config.locations.mobileCenter;
    } else {
      initialMapCenter = map.config.locations.center;
    }

    var initialMapZoomLevel;
    // check if on work page
    if (document.body.id == "work-page") {
      initialMapZoomLevel = map.config.workZoomLevel;
    } else if (site.isMobile) {
      initialMapZoomLevel = map.config.mobileZoomLevel;
    } else {
      initialMapZoomLevel = map.config.desktopZoomLevel;
    }

    site.googleMap = new google.maps.Map(document.getElementById("google-map"), {
      // center: map.config.locations.unionSquare,
      center: initialMapCenter,
      zoom: initialMapZoomLevel,
      fullscreenControl: false, // turn off full screen button
      // fullscreenControl: true,
      // fullscreenControlOptions: {
      //     position: google.maps.ControlPosition.BOTTOM_RIGHT
      // },
      mapTypeControl: false,
      styles: map.config.styles["default"],
    });

    // logo marker
    // var marker = new google.maps.Marker({
    var USQMarker = new google.maps.Marker({
      position: map.config.locations.initialUnionSquareLogo,
      map: site.googleMap,
      // icon: '/assets/images/logo/old-logo-dropshadow-100.png'
      icon: {
        // url: map.config.iconPath + 'logo.svg',
        url: map.config.iconPath + "logo/bw-logo.svg",
        scaledSize: new google.maps.Size(64, 64),
        // labelOrigin: new google.maps.Point(10, -10), // top
        labelOrigin: new google.maps.Point(32, -32), // top
        anchor: new google.maps.Point(32, 32), // top
        // optimized: false,
        // zIndex:99999999
      },
    });

    // green line t marker
    map.tMarker = new google.maps.Marker({
      position: map.config.locations.newTStop,
      // position: map.config.tstations['Union Square Station (coming 2021)'],
      map: site.googleMap,
      // icon: '/assets/images/logo/old-logo-dropshadow-100.png'
      icon: {
        // url: map.config.iconPath + 'map/green-t_2018.05.01.svg',
        url: map.config.iconPath + "map/green-t.svg",
        scaledSize: new google.maps.Size(60, 60),
        // labelOrigin: new google.maps.Point(10, -10), // top
        labelOrigin: new google.maps.Point(20, 70), // bottom
        anchor: new google.maps.Point(20, 20),
      },
      label: {
        // text: "Union Square Station (coming 2021)",
        text: "Union Square Station",
        color: "#555555",
        // var mbtaFontSize = '16px';
        fontSize: "14px",
      },
      visible: false,
    });

    /**
     * labels
     **/
    // icon defaults
    map.config.labelOrigin = new google.maps.Point(10, -10); // above
    // transit label defaults
    var textColorDefault = "#555555";
    var labelFontSize = "18px";
    // loop through json, from https://stackoverflow.com/a/5737136/4504073
    Object.keys(map.config.labels).forEach(function (key) {
      map.config.labelMarkers[key] = {};

      // custom icon
      if (key == "Logan Airport") {
        var icon = {
          url: map.config.iconPath + "map/ic_local_airport_black_24px.svg",
          scaledSize: new google.maps.Size(45, 45),
          labelOrigin: new google.maps.Point(25, -10), // top
        };
      } else if (key == "1 mile" || key == "2 miles" || key == "3 miles") {
        labelFontSize = "14px";
        textColor = "#FFFFFF";
        var icon = {
          // url: map.config.iconPath + 'map/red-rectangle-w3.svg',
          url: map.config.iconPath + "map/lightgray-rectangle.svg",
          scaledSize: new google.maps.Size(64, 64),
          opacity: 0.2,
        };
      } else {
        var icon = " ";
      }

      if (typeof text == "undefined") {
        var text = key;
      }
      if (typeof textColor == "undefined") {
        var textColor = textColorDefault;
      }

      // // check for custom position
      // if (typeof position === 'undefined' || position === null) {
      //     // variable is undefined or null
      //     var position = map.config.labels[key];
      // }

      map.config.labelMarkers[key] = new google.maps.Marker({
        map: site.googleMap,
        position: map.config.labels[key],
        icon: icon,
        label: {
          text: text,
          color: textColor,
          fontSize: labelFontSize,
        },
        visible: false, // hide on init in case mobile
      });

      // reset for next label
      labelFontSize = "18px";
    });

    /**
     * init t stations
     **/
    var labelFontSize = "14px";
    Object.keys(map.config.tstations).forEach(function (key) {
      map.config.tstationMarkers[key] = {};

      // if main T, offset
      // if (key == "Union Square Station (coming 2021)") {
      if (key == "Union Square Station") {
        var anchor = new google.maps.Point(15, -27);
      } else {
        var anchor = new google.maps.Point(15, 15);
      }

      map.config.tstationMarkers[key] = new google.maps.Marker({
        map: site.googleMap,
        position: map.config.tstations[key],
        icon: {
          url: map.config.iconPath + "map/green-t.svg",
          scaledSize: new google.maps.Size(30, 30),
          anchor: anchor,
          labelOrigin: new google.maps.Point(20, 40), // bottom
        },
        label: {
          text: key,
          color: textColorDefault,
          fontSize: labelFontSize,
        },
        visible: false, // hide on init in case mobile
      });
    });

    /**
     * concentric circles
     **/
    // loop through json, from https://stackoverflow.com/a/5737136/4504073
    Object.keys(map.config.circles).forEach(function (key) {
      map.config.concentricCircles[key] = {};

      map.config.concentricCircles[key] = new google.maps.Circle({
        map: site.googleMap,
        // strokeColor: site.colors.red,
        strokeColor: site.colors.lightgray,
        // strokeOpacity: 0.3,
        strokeOpacity: 1,
        // strokeWeight: 5,
        strokeWeight: 1,
        fillOpacity: 0,
        // center: map.config.locations.newTStop,
        center: map.config.locations.initialUnionSquareLogo, // phase II
        radius: map.config.circles[key].radius,
      });
    });

    /*
     * Nearby Searches and Transit
     * before map.everything() called
     */
    // Google nearby searches
    map.config.infoWindow = new google.maps.InfoWindow();
    // create the places service, https://developers.google.com/maps/documentation/javascript/places#PlaceSearchPaging
    map.config.service = new google.maps.places.PlacesService(site.googleMap);
    map.config.serviceNextPage = null;

    // Transit
    map.config.transitLayer = new google.maps.TransitLayer();

    /**
     * Final initializations
     * after other things load
     **/
    // show buildings on work page, after google map instantiated
    if (document.body.id == "work-page") {
      // show building highlghts
      map.dOverlayInit();
      map.config.dBlocksAreSet = true;

      map.showSubway();

      map.tMarker.setVisible();

      Object.keys(map.config.labels).forEach(function (key) {
        map.config.labelMarkers[key].setVisible();
      });

      // move & swap logo
      // USQMarker.setPosition(map.config.locations.realUnionSquareLogo);
      USQMarker.setIcon({
        url: map.config.iconPath + "logo/bw-logo.svg",
        scaledSize: new google.maps.Size(64, 64),
        anchor: new google.maps.Point(32, 32), // top
        // labelOrigin: new google.maps.Point(10, -10), // top
        // optimized: false,
        // zIndex:99999999
      });

      // show roads
      site.googleMap.setOptions({
        styles: map.config.styles["showroads"],
      });
    } else if (site.isMobile) {
      map.everything(false);
    } else {
      map.showLabels();
    }

    /*****
     * Map zoom level change
     * https://stackoverflow.com/a/28005383/4504073
     *****/
    site.googleMap.addListener("zoom_changed", function (e) {
      if (!site.isMobile) {
        console.log("zoom:", site.googleMap.getZoom());

        if (site.googleMap.getZoom() >= 17) {
          $(".popup-bubble-content").show();
        } else {
          // console.log('hide poi titles');
          $(".popup-bubble-content").hide();
        }

        // hide custom pins
        if (site.googleMap.getZoom() < 15) {
          map.clearMarkers();
        }

        // hide or show concentric circles
        if (site.googleMap.getZoom() >= 18 || site.googleMap.getZoom() <= 12) {
          // hide labels
          map.config.labelMarkers["1 mile"].setVisible(false);
          map.config.labelMarkers["2 miles"].setVisible(false);
          map.config.labelMarkers["3 miles"].setVisible(false);
        } else {
          // show concentric circles
          Object.keys(map.config.concentricCircles).forEach(function (key) {
            map.config.concentricCircles[key].setVisible();
          });
          map.config.labelMarkers["1 mile"].setVisible();
          map.config.labelMarkers["2 miles"].setVisible();
          map.config.labelMarkers["3 miles"].setVisible();
        }

        /*
         * d block outlines
         */
        if (site.googleMap.getZoom() >= 15) {
          // show d districts and green line trace, only once
          if (!map.config.dBlocksAreSet) {
            map.dOverlayInit();
            map.config.dBlocksAreSet = true;
            map.config.tstationMarkers[
              // "Washington St. Station (coming 2021)"
              "Washington St. Station"
            ].setMap(site.googleMap);
          }
        } else {
          // hide overlays, if already set
          if (map.config.dBlocksAreSet) {
            // map.dOverlayHide();
            map.config.tstationMarkers[
              // "Washington St. Station (coming 2021)"
              "Washington St. Station"
            ].setVisible(false);
          }
        }

        /*
         * neighborhood labels
         */
        // if zooming in and not on mobile and not already showing google labels
        if (!site.isMobile) {
          if (site.googleMap.getZoom() >= 13) {
            // turn on all neighborhood labels
            Object.keys(map.config.labels).forEach(function (key) {
              // if not a mile circle label
              if (key.indexOf("mile") === -1) {
                map.config.labelMarkers[key].setVisible();
              }
            });

            // show circles
            Object.keys(map.config.concentricCircles).forEach(function (key) {
              map.config.concentricCircles[key].setVisible();
            });
          } else {
            Object.keys(map.config.labels).forEach(function (key) {
              // if not a mile circle label
              map.config.labelMarkers[key].setVisible(false);
            });

            // hide circles
            Object.keys(map.config.concentricCircles).forEach(function (key) {
              map.config.concentricCircles[key].setVisible(false);
            });
          }

          if (site.googleMap.getZoom() >= 14) {
            Object.keys(map.config.tstations).forEach(function (key) {
              // if (key != "Washington St. Station (coming 2021)")
              if (key != "Washington St. Station") map.config.tstationMarkers[key].setVisible();
            });
          } else {
            Object.keys(map.config.tstations).forEach(function (key) {
              map.config.tstationMarkers[key].setVisible(false);
            });
          }

          // show Washington st. station on closer zoom
          if (site.googleMap.getZoom() >= 15) {
            map.config.tstationMarkers[
              // "Washington St. Station (coming 2021)"
              "Washington St. Station"
            ].setVisible();
          }

          // USQ T icon sizes visibility
          if (site.googleMap.getZoom() >= 17) {
            map.tMarker.setVisible();
            map.config.tstationMarkers[
              // "Union Square Station (coming 2021)"
              "Union Square Station"
            ].setVisible(false);
          } else if (site.googleMap.getZoom() >= 14) {
            map.tMarker.setVisible(false);
            map.config.tstationMarkers[
              // "Union Square Station (coming 2021)"
              "Union Square Station"
            ].setVisible();
          }
        }

        // if on mobile or showing google labels
        if (site.isShowingEverything || site.isShowingTransportation) {
          // hide all label markers
          Object.keys(map.config.labels).forEach(function (key) {
            map.config.labelMarkers[key].setVisible(false);
          });

          // Object.keys(map.config.tstations).forEach(function(key) {
          //     if(key != 'Union Square Station (coming 2021)') {
          //         map.config.tstationMarkers[key].setVisible(false);
          //     }
          // });
        }

        /**
         * t stop positions
         * change position, https://stackoverflow.com/a/5818200
         **/
        if (site.googleMap.getZoom() >= 15 && !site.isMobile) {
          map.config.tstationMarkers[
            // "Union Square Station (coming 2021)"
            "Union Square Station"
          ].setPosition(map.config.locations.newTStop);
        }

        /**
         * logo color and position
         **/
        if (site.googleMap.getZoom() >= 17 && !site.isMobile) {
          // larger logo b/c T larger too
          USQMarker.setIcon({
            url: map.config.iconPath + "logo/bw-logo.svg",
            scaledSize: new google.maps.Size(96, 96),
            anchor: new google.maps.Point(64, 64),
          });
        } else if ((site.googleMap.getZoom() == 15 || site.googleMap.getZoom() == 14) && !site.isMobile) {
          // color and moved
          // USQMarker.setPosition(map.config.locations.initialUnionSquareLogo);
          USQMarker.setIcon({
            url: map.config.iconPath + "logo/bw-logo.svg",
            scaledSize: new google.maps.Size(64, 64),
            anchor: new google.maps.Point(32, 32), // top
          });
        } else {
          // USQMarker.setPosition(map.config.locations.realUnionSquareLogo);
          USQMarker.setIcon({
            url: map.config.iconPath + "logo/bw-logo.svg",
            scaledSize: new google.maps.Size(64, 64),
            anchor: new google.maps.Point(32, 32), // top
          });
        }

        /**
         * Simple zoom in
         **/
        if (site.googleMap.getZoom() >= 15) {
          site.googleMap.setOptions({
            styles: map.config.styles["showroads"],
          });
        } else {
          site.googleMap.setOptions({
            styles: map.config.styles["default"],
          });
        }
      }
    });

    /*****
     * Controls
     *****/
    // Add controls to the map, allowing users to hide/show features.
    // move to scripts for global, button highlighting
    // var styleControl = document.getElementById('style-selector-control');

    // site.googleMap.controls[google.maps.ControlPosition.LEFT_BOTTOM].push(site.mapStyleControl);
    site.googleMap.controls[google.maps.ControlPosition.LEFT_TOP].push(site.mapStyleControl);

    // assign clearMarker to each map label when clicked
    // get by class name allows mobile controls to work as well
    var selectorControls = document.getElementsByClassName("selector-control");
    var mapList = document.getElementById("style-selector-control");

    // loop through all inputs/labels
    for (var i = selectorControls.length - 1; i >= 0; i--) {
      // add click event listener to each
      selectorControls[i].addEventListener("click", function () {
        // todo: call function to activate link so can apply to url query
        changeMap(this.id, this);
      });
    }

    // activate mobile dropdown
    $("#map-select").on("change", function () {
      // if(site.isShowingTransportation) {
      //     map.hideTransportation(); // clear transportation
      // }

      map.clearMarkers(); // clear markers

      var id = $(this).children(":selected").attr("data-id");

      if (id != "transportation") {
        map.centerAndZoom();
      }

      map.showPlaces(id);
    });

    /**
     * Get cached google map data
     * this way won't reach api limit
     **/
    // get restaurants
    $.getJSON("/google-results/restaurant", function (json) {
      map.config.restaurants = json;
    });

    // get retail stores
    $.getJSON("/google-results/retail", function (json) {
      map.config.retail = json;
    });

    // get activity locations
    $.getJSON("/google-results/discover", function (json) {
      map.config.discover = json;
    });

    /**
     * Check if anything need to show right away from url
     * March 2023
     **/
    const params = new Proxy(new URLSearchParams(window.location.search), {
      get: (searchParams, prop) => searchParams.get(prop),
    });
    // Get the value of "some_key" in eg "https://example.com/?some_key=some_value"
    let mapType = params.map; // "some_value"
    // console.log("params.map", params.map);

    // set testing interval to test when restaurants, retail and discover ajax have returned
    // from https://stackoverflow.com/a/3815085/4504073

    if (params.map) {
      const timer = setInterval(checkResults, 200);

      function checkResults() {
        if (map.config.restaurants && map.config.retail && map.config.discover) {
          // if made it here, stop asking
          clearInterval(timer);

          // then run map sequence
          changeMap(params.map);
          let mapEl = document.getElementById("google-map");
          mapEl.scrollIntoView({behavior: "smooth"});
        }
      }
    }

    // call appropriate map

    /**
     * Popup
     * from https://developers.google.com/maps/documentation/javascript/examples/overlay-popup
     */
    // popup = new Popup(
    //     new google.maps.LatLng(map.config.locations.center),
    //     document.getElementById('content'));
    // popup.setMap(site.googleMap);
  },

  /*
   * show d districts and green line path
   **/
  dOverlayInit: function () {
    /*
     * D block linework
     * from https://developers.google.com/maps/documentation/javascript/examples/polygon-simple
     */
    // Define the LatLng coordinates for the polygon's path.
    var d1Coords = [
      {lat: 42.379114, lng: -71.094038},
      {lat: 42.379473, lng: -71.093765},
      {lat: 42.379488, lng: -71.093706},
      {lat: 42.379496, lng: -71.09362},
      {lat: 42.379496, lng: -71.093561},
      {lat: 42.379465, lng: -71.093051},
      {lat: 42.379453, lng: -71.092936},
      {lat: 42.379443, lng: -71.092815},
      {lat: 42.379437, lng: -71.092676},
      {lat: 42.379429, lng: -71.092534},
      {lat: 42.379425, lng: -71.092442},
      {lat: 42.379429, lng: -71.0923},
      {lat: 42.379437, lng: -71.092169},
      {lat: 42.379445, lng: -71.092078},
      {lat: 42.378864, lng: -71.091984},
      {lat: 42.378359, lng: -71.091938},
      {lat: 42.378563, lng: -71.092539},
      {lat: 42.378946, lng: -71.09355},
    ];

    var d2Coords = [
      {lat: 42.377545, lng: -71.095108},
      {lat: 42.379022, lng: -71.094073}, // top left corner
      {lat: 42.378809, lng: -71.093456},
      {lat: 42.378306, lng: -71.093767},
      {lat: 42.377259, lng: -71.093749}, // start of eastern foot
      {lat: 42.377235, lng: -71.09329}, // top of eastern toe
      {lat: 42.376737, lng: -71.093349},
      {lat: 42.377, lng: -71.094},
    ];

    var d3Coords = [
      {lat: 42.377336, lng: -71.095261},
      {lat: 42.376952, lng: -71.095538},
      {lat: 42.376841, lng: -71.095492},
      {lat: 42.375872, lng: -71.095194},
      {lat: 42.375856, lng: -71.094929},
      {lat: 42.375854, lng: -71.09487},
      {lat: 42.375844, lng: -71.094779},
      {lat: 42.375826, lng: -71.094628},
      {lat: 42.375822, lng: -71.094532},
      {lat: 42.375822, lng: -71.094433},
      {lat: 42.375824, lng: -71.094352},
      {lat: 42.375832, lng: -71.094282},
      {lat: 42.375836, lng: -71.094234},
      {lat: 42.375848, lng: -71.094194},
      {lat: 42.375858, lng: -71.094135},
      {lat: 42.375858, lng: -71.094084},
      {lat: 42.37586, lng: -71.093987},
      {lat: 42.37586, lng: -71.093899},
      {lat: 42.375862, lng: -71.093832},
      {lat: 42.375854, lng: -71.093754},
      {lat: 42.375848, lng: -71.093676},
      {lat: 42.376544, lng: -71.093556},
      {lat: 42.376755, lng: -71.094036},
    ];

    var d4Coords1 = [
      {lat: 42.378674, lng: -71.094453},
      {lat: 42.378672, lng: -71.094477},
      {lat: 42.378662, lng: -71.094512},
      {lat: 42.378647, lng: -71.094542},
      {lat: 42.378454, lng: -71.094847},
      {lat: 42.378151, lng: -71.095336},
      {lat: 42.377991, lng: -71.094928},
    ];

    var d4Coords2 = [
      {lat: 42.377426, lng: -71.095328},
      {lat: 42.37765, lng: -71.095744},
      {lat: 42.377075, lng: -71.095575},
    ];

    var d4Coords3 = [
      {lat: 42.377806, lng: -71.095897},
      {lat: 42.377725, lng: -71.095991},
      {lat: 42.377612, lng: -71.096222},
      {lat: 42.377289, lng: -71.096044},
      {lat: 42.377226, lng: -71.096171},
      {lat: 42.377198, lng: -71.096146},
      {lat: 42.377164, lng: -71.096278},
      {lat: 42.376834, lng: -71.096224},
      {lat: 42.376879, lng: -71.09572},
      {lat: 42.376964, lng: -71.095658},
    ];

    var d5Coords1 = [
      {lat: 42.380212, lng: -71.09373},
      {lat: 42.380162, lng: -71.093247},
      {lat: 42.379988, lng: -71.093317},
      {lat: 42.379859, lng: -71.09337},
      {lat: 42.379809, lng: -71.093003},
      {lat: 42.379552, lng: -71.093091},
      {lat: 42.379578, lng: -71.093547},
      {lat: 42.379582, lng: -71.09362},
      {lat: 42.379568, lng: -71.09373},
      {lat: 42.379544, lng: -71.093824},
      {lat: 42.379593, lng: -71.09394},
    ];

    var d5Coords2 = [
      {lat: 42.379548, lng: -71.093022},
      {lat: 42.379869, lng: -71.09291},
      {lat: 42.379819, lng: -71.092572},
      {lat: 42.379839, lng: -71.092572},
      {lat: 42.379827, lng: -71.092422},
      {lat: 42.379837, lng: -71.092188},
      {lat: 42.379514, lng: -71.092218},
      {lat: 42.379506, lng: -71.092432},
      {lat: 42.379524, lng: -71.09274},
    ];

    var d6Coords = [
      {lat: 42.379619, lng: -71.095687},
      {lat: 42.379218, lng: -71.095803},
      {lat: 42.378987, lng: -71.095771},
      {lat: 42.379048, lng: -71.095419},
      {lat: 42.37882, lng: -71.095347},
      {lat: 42.378765, lng: -71.095097},
      {lat: 42.378715, lng: -71.094901},
      {lat: 42.378691, lng: -71.094813},
      {lat: 42.378664, lng: -71.094728},
      {lat: 42.378655, lng: -71.0947},
      {lat: 42.378636, lng: -71.094655},
      {lat: 42.378674, lng: -71.094593},
      {lat: 42.378695, lng: -71.094554},
      {lat: 42.378711, lng: -71.094514},
      {lat: 42.378719, lng: -71.094478},
      {lat: 42.378722, lng: -71.094435},
      {lat: 42.378717, lng: -71.094417}, // bottom left corner, on prospect st
      {lat: 42.379072, lng: -71.094188}, // top right corner, on prospect st
      {lat: 42.379134, lng: -71.094346}, // 2nd from top right
      {lat: 42.379248, lng: -71.094655}, // 3rd from top right
      {lat: 42.379607, lng: -71.095624},
      {lat: 42.379617, lng: -71.09567},
    ];

    var d7Coords1 = [
      {lat: 42.38008, lng: -71.096447},
      {lat: 42.380304, lng: -71.096152},
      {lat: 42.380316, lng: -71.096144},
      {lat: 42.38006, lng: -71.095758},
      {lat: 42.380153, lng: -71.095667},
      {lat: 42.380294, lng: -71.095913},
      {lat: 42.380468, lng: -71.095728},
      {lat: 42.380518, lng: -71.095814},
      {lat: 42.380568, lng: -71.09575},
      {lat: 42.380811, lng: -71.096064},
      {lat: 42.38035, lng: -71.096686},
    ];

    var d7Coords2 = [
      {lat: 42.380867, lng: -71.096536},
      {lat: 42.38076, lng: -71.096675},
      {lat: 42.380671, lng: -71.096911},
      {lat: 42.380399, lng: -71.096721},
      {lat: 42.380859, lng: -71.096088},
      {lat: 42.380968, lng: -71.096219},
      {lat: 42.381083, lng: -71.096485},
      {lat: 42.380962, lng: -71.096597},
    ];

    var lightGray = "#949494";
    // var dOpacity = 0.3;
    var dOpacity = 0.5;
    // var dFill = lightGray;
    var dFill = site.colors.blue;
    // var buildingFill = '#FFFFFF';
    var buildingFill = site.colors.blue;
    // var dFill = site.colors.blue;

    // D1
    map.config.dBlocks[1] = new google.maps.Polygon({
      paths: d1Coords,
      strokeOpacity: 0,
      fillColor: dFill,
      fillOpacity: dOpacity,
    });
    map.config.dBlocks[1].setMap(site.googleMap);

    // D2
    map.config.dBlocks[2] = new google.maps.Polygon({
      paths: d2Coords,
      strokeOpacity: 0,
      fillColor: dFill,
      fillOpacity: dOpacity,
    });
    map.config.dBlocks[2].setMap(site.googleMap);

    // // construct dotted polyline border to polygon
    // // from https://stackoverflow.com/a/41968742/4504073
    // map.config.currentPhasePath.setMap(site.googleMap);

    // D3
    map.config.dBlocks[3] = new google.maps.Polygon({
      paths: d3Coords,
      strokeOpacity: 0,
      fillColor: dFill,
      fillOpacity: dOpacity,
    });

    map.config.dBlocks[3].setMap(site.googleMap);

    // D4
    map.config.dBlocks[4] = new google.maps.Polygon({
      paths: [d4Coords1, d4Coords2, d4Coords3],
      strokeOpacity: 0,
      fillColor: dFill,
      fillOpacity: dOpacity,
    });

    map.config.dBlocks[4].setMap(site.googleMap);

    // D5
    map.config.dBlocks[5] = new google.maps.Polygon({
      paths: [d5Coords1, d5Coords2],
      strokeOpacity: 0,
      fillColor: dFill,
      fillOpacity: dOpacity,
    });

    map.config.dBlocks[5].setMap(site.googleMap);

    // D6
    map.config.dBlocks[6] = new google.maps.Polygon({
      paths: d6Coords,
      strokeOpacity: 0,
      fillColor: dFill,
      fillOpacity: dOpacity,
    });

    map.config.dBlocks[6].setMap(site.googleMap);

    // D7
    map.config.dBlocks[7] = new google.maps.Polygon({
      paths: [d7Coords1, d7Coords2],
      strokeOpacity: 0,
      fillColor: dFill,
      fillOpacity: dOpacity,
    });

    map.config.dBlocks[7].setMap(site.googleMap);
  },

  /*
   * hide d overlays when wrong zoom level
   **/
  dOverlayHide: function () {
    map.config.dBlocks[1].setVisible(false);
    map.config.dBlocks[2].setVisible(false);
    map.config.dBlocks[3].setVisible(false);
    map.config.dBlocks[4].setVisible(false);
    map.config.dBlocks[5].setVisible(false);
    map.config.dBlocks[6].setVisible(false);
    map.config.dBlocks[7].setVisible(false);
  },

  /*
   * show d overlays when wrong zoom level
   **/
  dOverlayShow: function () {
    map.config.dBlocks[1].setVisible();
    map.config.dBlocks[2].setVisible();
    map.config.dBlocks[3].setVisible();
    map.config.dBlocks[4].setVisible();
    map.config.dBlocks[5].setVisible();
    map.config.dBlocks[6].setVisible();
    map.config.dBlocks[7].setVisible();
  },

  /*
   * init d building outlines
   */
  dBuildingsInit: function () {
    // var dOpacity = 0.3;
    var dOpacity = 1;
    var buildingFill = site.colors.blue;

    var p10Coords = [
      {lng: -71.0940768, lat: 42.37897}, // top left
      {lng: -71.094345, lat: 42.37859}, // bottom left
      {lng: -71.09392, lat: 42.37843}, // bottom right
      {lng: -71.09365, lat: 42.37882}, // top right
    ];

    var p50Coords = [
      {lng: -71.0944326, lat: 42.3784042},
      {lng: -71.0946003, lat: 42.3782011},
      {lng: -71.0947921, lat: 42.3777548},
      {lng: -71.0949195, lat: 42.3777311},
      {lng: -71.0949132, lat: 42.3775907},
      {lng: -71.0941592, lat: 42.3773123},
      {lng: -71.0941133, lat: 42.3782816},
      {lng: -71.094416, lat: 42.3784019},
    ];

    var p60Coords = [
      {lng: -71.0952219, lat: 42.3772712},
      {lng: -71.0954446, lat: 42.3769681},
      {lng: -71.0952166, lat: 42.3766213},
      {lng: -71.0945031, lat: 42.3766887},
      {lng: -71.0943797, lat: 42.3768433},
      {lng: -71.0952166, lat: 42.3772693},
    ];

    // 10 Prospect
    map.config.dBlocks[10] = new google.maps.Polygon({
      paths: p10Coords,
      strokeOpacity: 0,
      fillColor: buildingFill,
      fillOpacity: dOpacity,
    });
    map.config.dBlocks[10].setMap(site.googleMap);

    // 50 Prospect
    map.config.dBlocks[50] = new google.maps.Polygon({
      paths: p50Coords,
      strokeOpacity: 0,
      fillColor: buildingFill,
      fillOpacity: dOpacity,
    });
    map.config.dBlocks[50].setMap(site.googleMap);

    // 60 Prospect
    map.config.dBlocks[60] = new google.maps.Polygon({
      paths: p60Coords,
      strokeOpacity: 0,
      fillColor: buildingFill,
      fillOpacity: dOpacity,
    });
    map.config.dBlocks[60].setMap(site.googleMap);
  },

  /*
   * init building labels
   */

  initDBuildingLabels: function () {
    map.config.buildingLabelOrigin = new google.maps.Point(-55, -55); // above
    var textColorDefault = "#555555";
    var labelFontSize = "18px";

    // loop through json, from https://stackoverflow.com/a/5737136/4504073
    Object.keys(map.config.buildingLabels).forEach(function (key) {
      map.config.buildingLabelMarkers[key] = {};
      // console.log(map.config.iconPath + 'map/' + key + '.svg');

      // custom icon
      var icon = {
        url: map.config.iconPath + "map/" + key + ".svg",
        scaledSize: new google.maps.Size(35, 35),
        opacity: 0.2,
        labelOrigin: new google.maps.Point(-550, -550),
        // anchor: new google.maps.Point(0, 10),
        // labelOrigin: new google.maps.Point(-55, -55);
      };

      map.config.buildingLabelMarkers[key] = new google.maps.Marker({
        map: site.googleMap,
        position: map.config.buildingLabels[key],
        icon: icon,
        // visible: false, // hide on init in case mobile
      });
    });

    // tracking flag
    map.config.dBuildingLabelsAreSet = true;
  },

  /*
   * hide d buildings
   **/
  hideBuildings: function () {
    if (map.config.buildingsAreVisible) {
      // hide outlines
      map.config.dBlocks[10].setVisible(false);
      map.config.dBlocks[50].setVisible(false);
      map.config.dBlocks[60].setVisible(false);

      map.config.buildingsAreVisible = false;
    }
  },

  /*
   * if buildings already instantiated, just show them!
   **/
  showBuildings: function () {
    if (!map.config.buildingsAreVisible) {
      // show outlines
      map.config.dBlocks[10].setVisible();
      map.config.dBlocks[50].setVisible();
      map.config.dBlocks[60].setVisible();

      map.config.buildingsAreVisible = true;
    }
  },

  /*
   * hide d building labels
   */

  hideDBuildingLabels: function () {
    Object.keys(map.config.buildingLabels).forEach(function (key) {
      map.config.buildingLabelMarkers[key].setVisible(false);
    });
  },

  /*
   * show d building labels
   */
  showDBuildingLabels: function () {
    Object.keys(map.config.buildingLabels).forEach(function (key) {
      map.config.buildingLabelMarkers[key].setVisible();
    });
  },

  /**
   * init subway
   **/
  initSubway: function () {
    /*
     * mbta paths
     * from https://developers.google.com/maps/documentation/javascript/examples/polyline-simple
     */

    // var decodedPath = google.maps.geometry.encoding.decodePath(map.config.routes.subway.linedata.orange);

    /**
     * show all subway routes
     **/
    Object.keys(map.config.routes.subway.linedata).forEach(function (key) {
      // determine correct color
      if (key == "orange") strokeColor = site.colors.orangeline;
      if (key == "blue") strokeColor = site.colors.blueline;
      if (key == "red") strokeColor = site.colors.redline;
      if (key == "green-b" || key == "green-c" || key == "green-d" || key == "green-e") strokeColor = site.colors.greenline;

      map.config.routes.subway.polylines[key] = new google.maps.Polyline({
        // decode the path before you use it
        path: google.maps.geometry.encoding.decodePath(map.config.routes.subway.linedata[key]),
        strokeColor: strokeColor,
        strokeOpacity: 1,
        strokeWeight: 2,
        fillOpacity: 0,
      });

      // add to map
      map.config.routes.subway.polylines[key].setMap(site.googleMap);
    });

    /*
     * GLX path
     * from https://developers.google.com/maps/documentation/javascript/examples/polyline-simple
     */
    // dashed line idea from https://stackoverflow.com/a/11399594/4504073
    var lineSymbolWidth = "0.01"; // like dots
    // var lineSymbolRepeat = '6px';
    // var lineSymbolRepeat = '15px'; // larger

    // control thickness based on first load
    var strokeWeight = 6;
    var lineSymbolRepeat = "12px";
    if (site.googleMap.getZoom() <= 15) {
      strokeWeight = 3;
      lineSymbolRepeat = "6px";
    }

    var lineSymbol = {
      path: "M 0,-" + lineSymbolWidth + " 0," + lineSymbolWidth,
      strokeOpacity: 1,
      strokeColor: "#00843D",
      strokeWeight: strokeWeight,
    };

    /**
     * Green line to Union Square
     **/
    var newGreenLineCoordinates = [
      {lat: 42.37734, lng: -71.095},
      {lat: 42.37694, lng: -71.0942},
      {lat: 42.37663, lng: -71.0934},
      {lat: 42.37636, lng: -71.0926},
      {lat: 42.37612, lng: -71.0916},
      {lat: 42.3759, lng: -71.09},
      {lat: 42.37584, lng: -71.0895},
      {lat: 42.37565, lng: -71.088},
      {lat: 42.3747, lng: -71.082},
      {lat: 42.3744, lng: -71.081}, // split
      // {lat: 42.37157, lng: -71.0766}, // new lechemere location (est.)
      {lat: 42.370946, lng: -71.077057},
    ];

    map.config.greenLinePath = new google.maps.Polyline({
      path: newGreenLineCoordinates,
      strokeOpacity: 0,
      icons: [
        {
          icon: lineSymbol,
          offset: "0",
          repeat: lineSymbolRepeat,
        },
      ],
    });

    /**
     * Green line to East Somerville Station
     **/
    var secondGreenLineCoordinates = [
      {lat: 42.3744, lng: -71.081}, // split
      // map.config.routes.subway.labels['East Somerville'],
      // map.config.tstations["Washington St. Station (coming 2021)"],
      map.config.tstations["Washington St. Station"],
      {lat: 42.3865, lng: -71.0939}, // curve to gilman
      map.config.routes.subway.labels["Gilman Square"],
      {lat: 42.3912, lng: -71.1033}, // curve to magoun
      map.config.routes.subway.labels["Magoun Square"],
      map.config.routes.subway.labels["Ball Square"],
      map.config.routes.subway.labels["College Avenue"],
    ];

    map.config.greenLinePath2 = new google.maps.Polyline({
      path: secondGreenLineCoordinates,
      strokeOpacity: 0,
      icons: [
        {
          icon: lineSymbol,
          offset: "0",
          repeat: lineSymbolRepeat,
        },
      ],
    });

    map.config.greenLinePath.setMap(site.googleMap);
    map.config.greenLinePath2.setMap(site.googleMap);
    // add flag so don't clear until set
    map.config.isShowingGLX = true;

    // // hide original t station labels
    // Object.keys(map.config.tstations).forEach(function(key) {

    //     // hide all custom stations except for Union Square
    //     if(key != 'Union Square Station (coming 2021)') {
    //         map.config.tstationMarkers[key].setVisible(false);
    //     }

    // });

    // subway labels, not on phone
    if (!site.isMobile) {
      Object.keys(map.config.routes.subway.labels).forEach(function (key) {
        // if initial map load, only show certain ones, else show all
        // if(map.config.routes.subway.labels[key].hasOwnProperty('showInitial')) {
        if (true) {
          // init as object
          map.config.routes.subway.labelMarkers[key] = {};

          // custom icon
          if (map.config.routes.subway.labels[key].hasOwnProperty("icon")) var icon = map.config.iconPath + "map/" + map.config.routes.subway.labels[key].icon + ".svg";
          else var icon = map.config.iconPath + "map/orange-t.svg";

          var icon = {
            url: icon,
            // url: map.config.iconPath + 'map/orange-green-purple-t.svg',
            scaledSize: new google.maps.Size(25, 25),
            labelOrigin: new google.maps.Point(15, 35), // bottom
            anchor: new google.maps.Point(10, 10),
          };

          // prep default text
          if (map.config.routes.subway.labels[key].hideText) {
            var text = " ";
          } else if (typeof text == "undefined") {
            var text = key;
          }

          // prep text color
          if (typeof textColor == "undefined") {
            var textColor = map.config.textColorDefault;
          }

          map.config.routes.subway.labelMarkers[key] = new google.maps.Marker({
            map: site.googleMap,
            position: map.config.routes.subway.labels[key],
            icon: icon,
            label: {
              text: text,
              color: textColor,
              fontSize: "14px",
            },
          });
        }
      });
    }

    // flag for only initializing once
    map.config.subwaysInitialized = true;
  },

  showSubway: function () {
    // show subway
    if (!map.config.subwaysInitialized) {
      map.initSubway();
    } else {
      // show subway stations

      // show subway lines
      Object.keys(map.config.routes.subway.linedata).forEach(function (key) {
        map.config.routes.subway.polylines[key].setVisible();
      });

      // show subway labels
      Object.keys(map.config.routes.subway.labelMarkers).forEach(function (key) {
        map.config.routes.subway.labelMarkers[key].setVisible();
      });

      // show glx
      map.config.greenLinePath.setVisible();
      map.config.greenLinePath2.setVisible();
    }
  },

  hideSubway: function () {
    // hide if visible
    if (map.config.subwaysInitialized) {
      // hide subway lines
      Object.keys(map.config.routes.subway.linedata).forEach(function (key) {
        map.config.routes.subway.polylines[key].setVisible(false);
      });

      // hide glx
      map.config.greenLinePath.setVisible(false);
      map.config.greenLinePath2.setVisible(false);

      // hide most subway labels
      Object.keys(map.config.routes.subway.labelMarkers).forEach(function (key) {
        if (key != "Lechmere Station (5 min)") {
          map.config.routes.subway.labelMarkers[key].setVisible(false);
        }
      });

      // show original t station labels
      Object.keys(map.config.tstations).forEach(function (key) {
        // hide all custom stations except for Union Square
        // if (key != "Union Square Station (coming 2021)") {
        if (key != "Union Square Station") {
          map.config.tstationMarkers[key].setVisible(false);
        }
      });
    }
  },

  initBus: function () {
    // dashed line idea from https://stackoverflow.com/a/11399594/4504073
    var lineSymbol = {
      path: "M 0,-1 0,1",
      strokeOpacity: 1,
      strokeColor: site.colors.bus,
      strokeWeight: 3,
    };

    /**
     * show all bus routes
     **/
    Object.keys(map.config.routes.bus.linedata).forEach(function (key) {
      map.config.routes.bus.polylines[key] = new google.maps.Polyline({
        // decode the path before you use it
        path: google.maps.geometry.encoding.decodePath(map.config.routes.bus.linedata[key]),
        strokeOpacity: 0,
        icons: [
          {
            icon: lineSymbol,
            offset: "0",
            repeat: "15px",
          },
        ],
      });

      // add to map
      map.config.routes.bus.polylines[key].setMap(site.googleMap);
    });

    /**
     * show all bus labels
     **/
    Object.keys(map.config.routes.bus.labels).forEach(function (key) {
      // init as object
      map.config.routes.bus.labelMarkers[key] = {};

      var icon = {
        url: map.config.iconPath + "map/bus-icon.svg",
        scaledSize: new google.maps.Size(25, 25),
        labelOrigin: new google.maps.Point(15, 35), // bottom
      };

      // prep default text
      if (typeof text == "undefined") {
        var text = key;
      }

      // prep text color
      if (typeof textColor == "undefined") {
        var textColor = map.config.textColorDefault;
      }

      map.config.routes.bus.labelMarkers[key] = new google.maps.Marker({
        map: site.googleMap,
        position: map.config.routes.bus.labels[key],
        icon: icon,
        label: {
          text: text,
          color: textColor,
          fontSize: "14px",
        },
      });
    });

    map.config.bussesInitialized = true;
  },

  showBus: function () {
    console.log("showBus()");

    // show bus
    if (!map.config.bussesInitialized) {
      map.initBus();
    } else {
      // show bus routes
      Object.keys(map.config.routes.bus.linedata).forEach(function (key) {
        map.config.routes.bus.polylines[key].setVisible();
      });

      // show bus labels
      Object.keys(map.config.routes.bus.labels).forEach(function (key) {
        map.config.routes.bus.labelMarkers[key].setVisible();
      });
    }
  },

  hideBus: function () {
    if (map.config.bussesInitialized) {
      // hide bus routes
      Object.keys(map.config.routes.bus.linedata).forEach(function (key) {
        map.config.routes.bus.polylines[key].setVisible(false);
      });

      // hide bus labels
      Object.keys(map.config.routes.bus.labels).forEach(function (key) {
        map.config.routes.bus.labelMarkers[key].setVisible(false);
      });
    }
  },

  hideTransportation: function () {
    console.log("hideTransportation()");

    map.hideSubway();
    map.hideBus();

    site.isShowingTransportation = false;
  },

  highlightButton: function (index) {
    // console.log("index", index);

    // remove other highlights
    // regex from https://stackoverflow.com/a/47548339/4504073
    const highlightClass = new RegExp(/\bhighlight-button-.+?\b/, "g");
    // console.log("highlightClass", highlightClass);

    site.mapStyleControl.className = site.mapStyleControl.className.replace(highlightClass, "");

    // highlight this button
    site.mapStyleControl.classList.add("highlight-button-" + index);
  },

  /*
   * @JSON results show map results from cache
   * @string Status so can set markers, really a test for real-time nearby places search
   **/
  cache: function () {
    map.nearbyCallback(map.config.restaurants[0].results, map.config.restaurants[0].status);
  },

  /**
   * Transportation
   **/
  transportation: function () {
    map.showSubway();

    map.showBus();

    // flag to prevent t stations from coming back
    site.isShowingTransportation = true;
  },

  /**
   * Restaurant
   * found by https://stackoverflow.com/a/21449379
   * from https://developers.google.com/maps/documentation/javascript/examples/place-search
   * supported types https://developers.google.com/places/web-service/supported_types
   **/
  restaurant: function () {
    // set icon color in highest scope so can get right one
    map.config.nearbyType = "restaurant";

    // // show some streets
    // site.googleMap.setOptions({
    //     styles: map.config.styles['showroads']
    // });

    // using cache
    map.nearbyCallback(map.config.restaurants.results, map.config.restaurants.status, "undefined", "restaurant");
  },

  /**
   * Retail
   * need to have function to recieve results and status, so can explicity pass to map.nearbyCallback, along with type so don't overwrite marker id names so can remove all markers
   **/
  retail: function () {
    // set icon color in highest scope so can get right one
    map.config.nearbyType = "retail";

    // // show some streets
    // site.googleMap.setOptions({
    //     styles: map.config.styles['showroads']
    // });

    map.nearbyCallback(map.config.retail.results, map.config.retail.status, "undefined", "retail");
  },

  /**
   * Discover
   **/
  discover: function () {
    // set icon color in highest scope so can get right one
    map.config.nearbyType = "discover";

    // show some streets
    site.googleMap.setOptions({
      styles: map.config.styles["showroadsnoparks"],
    });

    map.nearbyCallback(map.config.discover.results, map.config.discover.status, "undefined", "discover");
  },

  /**
   * Transit
   **/
  transit: function () {
    // show transit features
    site.googleMap.setOptions({
      styles: map.config.styles["transit"],
    });
    // show special transit layer
    map.config.transitLayer.setMap(site.googleMap);
    // show custom markers
    // map.config.markers.northStationMarker.setVisible();
    // map.config.markers.communityCollegeMarker.setVisible();

    // set icon color in highest scope so can get right one somewhere else?
    map.config.nearbyType = "transit";

    map.config.service.nearbySearch(
      {
        location: map.config.locations.unionSquare,
        radius: map.config.nearbyRadius, // 1/2 mile in meters
        type: ["transit_station"],
      },
      map.nearbyCallback
    );
  },

  /*
   * Everything, just for fun
   * @param transit, boolean if not want to show transit
   **/
  everything: function (transit) {
    // default value, from https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/Default_parameters
    // transit is assumed to be undefined, or true
    // this build for mobile init
    transit = typeof transit !== "undefined" ? false : true;

    // show everything
    site.googleMap.setOptions({
      styles: map.config.styles["show"],
    });

    // show special transit layer, if not false
    if (transit) map.config.transitLayer.setMap(site.googleMap);

    // turn off custom map labels so don't overlap with google labels
    map.hideLabels();

    // set flag so zoom doesn't bring labels back on desktop
    site.isShowingEverything = true;
  },

  /*
   * hide everything for resizing to desktop
   **/
  hideEverything: function () {
    // remove other styles
    site.googleMap.setOptions({
      // styles: map.config.styles['showroads']
    });

    // set flag so zoom doesn't bring labels back on desktop
    site.isShowingEverything = false;
  },

  /**
   * Called when nearby service returns from api
   * from https://developers.google.com/maps/documentation/javascript/examples/place-search
   **/
  nearbyCallback: function (results, status, pagination, type) {
    // create markers from the nearby query
    if (status === google.maps.places.PlacesServiceStatus.OK) {
      for (var i = 0; i < results.length; i++) {
        map.createMarker(results[i], type);
      }
    }
  },

  /**
   * Create marker, initially for nearby places search
   * from https://developers.google.com/maps/documentation/javascript/examples/place-search
   **/
  createMarker: function (place, type) {
    var placeLoc = place.geometry.location;

    // set color
    switch (map.config.nearbyType) {
      case "restaurant":
        iconName = "red-place";
        break;
      case "retail":
        iconName = "green-place";
        break;
      case "discover":
        iconName = "blue-place";
        break;
      case "transit":
        iconName = "black-place";
        break;
      default:
        iconName = "red-place";
    }

    // init
    map.config.markers[type + "_" + place.id] = {};

    // add marker
    map.config.markers[type + "_" + place.id].marker = new google.maps.Marker({
      map: site.googleMap,
      position: place.geometry.location,
      clickable: false, // no cursor pointer
      icon: {
        // url: map.config.iconPath + 'map/' + iconName + '.svg',
        url: map.config.iconPath + "map/" + iconName + ".svg",
        // scaledSize: new google.maps.Size(50, 50),
        // scaledSize: new google.maps.Size(35, 35),
        scaledSize: new google.maps.Size(place.iconSize, place.iconSize), // small or large sizes are set in site.googlemap.php controller
        labelOrigin: map.config.labelOrigin,
        // optimized: false,
        // zIndex: 1
      },
    });

    // google.maps.event.addListener(map.config.markers[type + '_' + place.id], 'click', function() {
    //     map.config.infoWindow.setContent(place.name);
    //     map.config.infoWindow.open(map, this);
    // });

    /*
     * add popup label
     * from https://developers.google.com/maps/documentation/javascript/examples/overlay-popup
     * @param location
     * @param name
     * @param label offset from left
     * @param label offset from bottom
     */
    map.config.markers[type + "_" + place.id].popup = new Popup(
      // new google.maps.LatLng(placeLoc.lat(), placeLoc.lng()),
      new google.maps.LatLng(placeLoc.lat, placeLoc.lng),
      place.name,
      place.offsetLeft,
      place.offsetBottom
    );
    map.config.markers[type + "_" + place.id].popup.setMap(site.googleMap);

    // // setmap from above has no callback
    // // so need to hack it below
    // // inspired by https://stackoverflow.com/a/37949254/4504073
  },

  /**
   * Clear all markers from map
   * useful when switching highlighted features
   **/
  clearMarkers: function () {
    // iterate over object, from https://stackoverflow.com/a/18202926/4504073
    Object.keys(map.config.markers).forEach(function (key, index) {
      // key: the name of the object key
      // index: the ordinal position of the key within the object
      // set each marker to invisible
      map.config.markers[key].marker.setVisible(false);
      // hide popups if exist
      if (map.config.markers[key].hasOwnProperty("popup")) {
        // map.config.markers[key].popup.display = 'none';
        map.config.markers[key].popup.setMap(null);
      }
    });

    // // remove other styles
    // site.googleMap.setOptions({
    //     styles: map.config.styles['default']
    // });

    // flags
    site.isShowingMarkers = false;
    site.isShowingEverything = false;
  },

  /*
   * center and zoom map, based on if on mobile or desktop
   * zoom to better level, https://stackoverflow.com/a/12458494/4504073
   **/
  centerAndZoom: function () {
    if (site.isMobile) {
      site.googleMap.setCenter(map.config.locations.mobileUnionSquareZoomCenter);
      site.googleMap.setZoom(map.config.mobileSecondaryZoomLevel);
    } else if (site.isDesktop) {
      site.googleMap.setCenter(map.config.locations.unionSquareZoomCenter);
      site.googleMap.setZoom(map.config.secondaryZoomLevel);
    } else if (site.isMassive) {
      site.googleMap.setCenter(map.config.locations.massiveUnionSquareZoomCenter);
      site.googleMap.setZoom(map.config.massiveSecondaryZoomLevel);
    }
  },

  /*
   * Show Places
   * show related places based on id string param
   **/
  showPlaces: function (place) {
    // convert string dash to underscore to make function calling possible
    var functionName = place.replace("-", "_");
    // set flag so zoom can bring labels back on desktop
    if (place != "everything") site.isShowingEverything = false;
    // call own function by name from string, https://stackoverflow.com/a/359910/4504073

    if (window["map"][functionName] !== undefined) {
      // safe to use the function
      window["map"][functionName]();
    } else {
      console.log('window["map"][functionName]', window["map"][functionName]);
    }

    // reset body classes
    document.body.classList.remove("map-show-restaurant", "map-show-retail", "map-show-discover");
    // add class to body so map marker labels can change color
    document.body.classList.add("map-show-" + functionName);
    // turn on t symbol
    // map.tMarker.setVisible();
    // flag
    site.isShowingMarkers = true;
  },

  /*
   * Show custom labels
   **/
  showLabels: function () {
    Object.keys(map.config.labels).forEach(function (key) {
      map.config.labelMarkers[key].setVisible();
    });

    Object.keys(map.config.tstations).forEach(function (key) {
      // if (key != "Washington St. Station (coming 2021)")
      if (key != "Washington St. Station") map.config.tstationMarkers[key].setVisible();
    });

    Object.keys(map.config.concentricCircles).forEach(function (key) {
      map.config.concentricCircles[key].setVisible();
    });

    // flags
    site.isHidingLabels = false;
    site.isShowingLabels = true;
  },

  /*
   * Hide custom labels
   **/
  hideLabels: function () {
    // hide all custom labels
    Object.keys(map.config.labels).forEach(function (key) {
      map.config.labelMarkers[key].setVisible(false);
    });
    Object.keys(map.config.tstations).forEach(function (key) {
      map.config.tstationMarkers[key].setVisible(false);
    });
    Object.keys(map.config.concentricCircles).forEach(function (key) {
      map.config.concentricCircles[key].setVisible(false);
    });
    // flags
    site.isHidingLabels = true;
    site.isShowingLabels = false;
  },
};

/** Defines the Popup class.
 * https://developers.google.com/maps/documentation/javascript/examples/overlay-popup
 */

function definePopupClass() {
  /**
   * A customized popup on the map.
   * @param {!google.maps.LatLng} position
   * @param {!Element} content
   *
   * LJH
   * @param offsetLeft
   *
   * @constructor
   * @extends {google.maps.OverlayView}
   */
  Popup = function (position, name, offsetLeft, offsetBottom) {
    // set defaults for offset labelling, from https://stackoverflow.com/a/894877/4504073
    // THESE ARE NOW SET IN site.googlemap.php
    // offsetLeft = typeof offsetLeft !== 'undefined' ? offsetLeft : 0;
    // offsetBottom = typeof offsetBottom !== 'undefined' ? offsetBottom : 0;

    this.position = position;

    // content.classList.add('popup-bubble-content');
    // make content div
    var content = document.createElement("div");
    content.classList.add("popup-bubble-content");
    content.innerHTML = name;

    // make anchor div
    var pixelOffset = document.createElement("div");
    pixelOffset.classList.add("popup-bubble-anchor");
    pixelOffset.appendChild(content);

    // add label offset so no collisions in google
    pixelOffset.style.position = "absolute";
    pixelOffset.style.left = offsetLeft + "px";
    pixelOffset.style.bottom = offsetBottom + "px";

    this.anchor = document.createElement("div");
    this.anchor.classList.add("popup-tip-anchor");
    this.anchor.appendChild(pixelOffset);

    // Optionally stop clicks, etc., from bubbling up to the map.
    this.stopEventPropagation();
  };
  // NOTE: google.maps.OverlayView is only defined once the Maps API has
  // loaded. That is why Popup is defined inside initMap().
  Popup.prototype = Object.create(google.maps.OverlayView.prototype);

  /** Called when the popup is added to the map. */
  Popup.prototype.onAdd = function () {
    this.getPanes().floatPane.appendChild(this.anchor);
  };

  /** Called when the popup is removed from the map. */
  Popup.prototype.onRemove = function () {
    if (this.anchor.parentElement) {
      this.anchor.parentElement.removeChild(this.anchor);
    }
  };

  /** Called when the popup needs to draw itself. */
  Popup.prototype.draw = function () {
    var divPosition = this.getProjection().fromLatLngToDivPixel(this.position);
    // Hide the popup when it is far out of view.
    var display = Math.abs(divPosition.x) < 4000 && Math.abs(divPosition.y) < 4000 ? "block" : "none";

    if (display === "block") {
      this.anchor.style.left = divPosition.x + "px";
      this.anchor.style.top = divPosition.y + "px";
    }
    if (this.anchor.style.display !== display) {
      this.anchor.style.display = display;
    }
  };

  /** Stops clicks/drags from bubbling up to the map. */
  Popup.prototype.stopEventPropagation = function () {
    var anchor = this.anchor;
    anchor.style.cursor = "auto";

    ["click", "dblclick", "contextmenu", "wheel", "mousedown", "touchstart", "pointerdown"].forEach(function (event) {
      anchor.addEventListener(event, function (e) {
        e.stopPropagation();
      });
    });
  };
}

/**
 * what happens when want to change the map?
 * applies to legend and url queries, 03.2023
 */
function changeMap(placeId, placeEl = null) {
  // console.log("changeMap", placeId);
  // if google link
  if (placeId == "directions") {
    // window.open("https://goo.gl/maps/MZTejMpp7eSXBVDx9"); // old location? 31 Union Square
    window.open("https://maps.app.goo.gl/8xjrqGXKeNgMcD8k6"); // 10 Prospect St
    return false;
  }

  if (site.isShowingTransportation) {
    map.hideTransportation(); // clear transportation
  }

  map.clearMarkers();

  // center and zoom if not transportation
  if (placeId != "transportation") {
    map.centerAndZoom();
    // map.showSubway();
  } else {
    // manually remove everything layer b/c not clearing with centerAndZoom
    map.hideEverything();
  }

  map.showPlaces(placeId);

  // highlight if a button was clicked
  if (placeEl) {
    // get this index
    let placeLi = placeEl.closest("li");
    let index = $(placeLi).index();
    // relative index
    map.highlightButton(index + 1);
  } else {
    // highlight a place if url used
    let mapButtons = document.querySelectorAll("#style-selector-control li");
    // console.log("mapButtons", mapButtons);
    // loop through available buttons
    mapButtons.forEach(function (mapButton, index) {
      // console.log("mapButton", mapButton);
      // get button id
      let buttonId = mapButton.querySelector("input").id;
      // if button id == placeId, highlight the button
      if (buttonId == placeId) {
        map.highlightButton(index + 1);
      }
      // console.log("buttonId", buttonId);
      // console.log("index", index);
    });
  }
}
